import { Host, h } from "@stencil/core";
import { makeLinesClampable } from "../../common/line-clamp";
import { HEIGHT_MEASURING, LINE_CLAMP, LINE_MEASURING } from "../../common/reserverd-names";
/**
 * @part content - The main content displayed in the control. This part only applies when `format="Text"` and lineClamp="true".
 *
 * @slot - The slot for the content.
 */
export class TextBlock {
    constructor() {
        this.contentLines = 0;
        this.maxLines = 0;
        this.format = "Text";
        this.lineClamp = false;
        this.tooltip = undefined;
        this.tooltipShowMode = "always";
        makeLinesClampable(this, "." + LINE_CLAMP, "." + HEIGHT_MEASURING, "." + LINE_MEASURING, true);
    }
    element;
    getTooltip() {
        const noNeedToDisplayTooltip = !this.tooltip ||
            (this.tooltipShowMode === "line-clamp" &&
                this.lineClamp &&
                this.contentLines <= this.maxLines);
        return noNeedToDisplayTooltip ? null : this.tooltip;
    }
    render() {
        const justRenderTheSlot = this.format === "HTML" || !this.lineClamp;
        return (h(Host, { role: this.format === "Text" && !this.lineClamp ? "paragraph" : null, title: this.getTooltip() }, justRenderTheSlot ? (h("slot", null)) : ([
            h("div", { class: LINE_MEASURING }, "A"),
            h("div", { class: HEIGHT_MEASURING }),
            h("p", { class: `content ${LINE_CLAMP}`, part: "content", style: { "--max-lines": this.maxLines.toString() } }, h("slot", null))
        ])));
    }
    static get is() { return "ch-textblock"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["textblock.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["textblock.css"]
        };
    }
    static get properties() {
        return {
            "format": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"Text\" | \"HTML\"",
                    "resolved": "\"HTML\" | \"Text\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "It specifies the format that will have the textblock control.\n\n - If `format` = `HTML`, the textblock control works as an HTML div and\n   the innerHTML will be taken from the default slot.\n\n - If `format` = `Text`, the control works as a normal textblock control\n   and it is affected by most of the defined properties."
                },
                "attribute": "format",
                "reflect": false,
                "defaultValue": "\"Text\""
            },
            "lineClamp": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "True to cut text when it overflows, showing an ellipsis."
                },
                "attribute": "line-clamp",
                "reflect": false,
                "defaultValue": "false"
            },
            "tooltip": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine the tooltip text that will be displayed when the pointer is over\nthe control"
                },
                "attribute": "tooltip",
                "reflect": false
            },
            "tooltipShowMode": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"always\" | \"line-clamp\"",
                    "resolved": "\"always\" | \"line-clamp\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine the way that the tooltip text will be displayed"
                },
                "attribute": "tooltip-show-mode",
                "reflect": false,
                "defaultValue": "\"always\""
            }
        };
    }
    static get states() {
        return {
            "contentLines": {},
            "maxLines": {}
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=textblock.js.map
